(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-cart"] && !Shopify.designMode) return;
  try {
    
function initFindCart(root) {
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  let busy=false;
  const status=root.querySelector('[data-cart-status]');
  const setBusy=value=>{busy=value;root.setAttribute('aria-busy',String(value));root.querySelectorAll('[data-step], [data-checkout], [data-line-quantity], [data-addon-form] button').forEach(el=>el.disabled=value);};
  root.querySelectorAll('[data-step]').forEach(el=>el.hidden=false);
  const fallback=root.querySelector('[data-native-update]');if(fallback)fallback.hidden=true;
  const change=async(line,quantity)=>{
    if(busy)return;
    const input=line.querySelector('[data-line-quantity]');
    if(!Number.isInteger(quantity)||quantity<0){input.reportValidity();return;}
    setBusy(true);status.textContent=root.dataset.updating;
    try{
      const response=await fetch(root.dataset.root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:line.dataset.key,quantity,sections:[root.dataset.sectionId],sections_url:window.location.pathname})});
      const data=await response.json();
      if(!response.ok)throw new Error(typeof data.description==='string'?data.description:root.dataset.error);
      const html=data.sections?.[root.dataset.sectionId];
      if(!html){window.location.reload();return;}
      const next=new DOMParser().parseFromString(html,'text/html').querySelector('[data-find-cart]');
      if(!next){window.location.reload();return;}
      root.replaceWith(next);initFindCart(next);
      next.querySelector('[data-cart-status]').textContent=next.dataset.updated;
      next.querySelector('[data-cart-status]').focus({preventScroll:true});
      document.querySelectorAll('.find-header-actions a').forEach(a=>{if(new URL(a.href).pathname===root.dataset.cartUrl)a.textContent=root.dataset.cartLabel+data.item_count+')';});
    }catch(error){setBusy(false);status.textContent=error.message||root.dataset.error;status.setAttribute('role','alert');fallback.hidden=false;}
  };
  root.addEventListener('click',event=>{
    const button=event.target.closest('[data-step]');
    const remove=event.target.closest('[data-remove]');
    if(!button&&!remove)return;
    event.preventDefault();if(busy)return;
    const line=(button||remove).closest('[data-cart-line]');
    const input=line.querySelector('[data-line-quantity]');
    const quantity=remove?0:Math.max(0,Number(input.value)+Number(button.dataset.step));
    input.value=quantity;change(line,quantity);
  });
  root.addEventListener('change',event=>{if(event.target.matches('[data-line-quantity]'))change(event.target.closest('[data-cart-line]'),Number(event.target.value));});
  root.addEventListener('input',event=>{if(event.target.matches('[data-line-quantity]')){const checkout=root.querySelector('[data-checkout]');if(checkout)checkout.disabled=true;}});
  root.querySelector('[data-cart-form]')?.addEventListener('submit',event=>{if(busy)event.preventDefault();});
  const addon=root.querySelector('[data-addon-select]');
  addon?.addEventListener('change',()=>{root.querySelector('[data-addon-price]').textContent=addon.selectedOptions[0].dataset.price;});
  root.querySelector('[data-addon-form]')?.addEventListener('submit',event=>{if(busy){event.preventDefault();return;}busy=true;root.querySelector('[data-addon-form] button').disabled=true;});
  window.addEventListener('pageshow',()=>{setBusy(false);});
}
document.querySelectorAll('[data-find-cart]').forEach(initFindCart);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-find-cart]').forEach(initFindCart));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-product-landing"] && !Shopify.designMode) return;
  try {
    
function initFindProduct(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const select = root.querySelector('[data-variant-select]');
  const form = root.querySelector('.find-form');
  const main = root.querySelector('[data-main-image]');
  const buttons = [...root.querySelectorAll('[data-atc], [data-sticky-atc]')];
  const thumbs = [...root.querySelectorAll('[data-image-id].find-gallery__thumb')];
  const sticky = root.querySelector('[data-sticky]');
  const note = root.querySelector('[data-variant-note]');
  const offers = root.querySelector('[data-offers]');
  const quantity = form?.querySelector('[name="quantity"]');
  const error = root.querySelector('[data-purchase-error]');
  let state = { available: false, bundle: false, pending: false, items: [] };
  let busy = false;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:root.dataset.currency || 'GBP'}).format(cents / 100);
  const showImage = btn => {
    if (!main || !btn) return;
    main.removeAttribute('srcset'); main.src = btn.dataset.src; main.alt = btn.dataset.alt;
    thumbs.forEach(t => { const active = t === btn; t.classList.toggle('is-active', active); t.setAttribute('aria-pressed', String(active)); });
  };
  thumbs.forEach(btn => btn.addEventListener('click', () => showImage(btn)));
  if (offers) offers.hidden = false;
  const sync = (updateUrl = false, updateImage = false) => {
    const first = select?.selectedOptions[0]; if (!first) return;
    const key = offers?.querySelector('input[name="find_offer"]:checked')?.value || 'single';
    const detail = offers?.querySelector('[data-offer-detail="' + key + '"]');
    const bundled = !!detail;
    offers?.querySelectorAll('[data-offer-detail]').forEach(el => { el.hidden = el !== detail; el.querySelectorAll('select').forEach(control => { control.disabled = el !== detail; }); });
    const extra = detail ? [...detail.querySelectorAll('select')].map(control => control.selectedOptions[0]).filter(Boolean) : [];
    const count = bundled ? 1 : Number(quantity?.value || 1);
    const amounts = new Map();
    const selected = [first,...extra];
    selected.forEach(o => amounts.set(o.value,(amounts.get(o.value) || 0) + count));
    let available = selected.every(o => o.dataset.available === 'true' && (o.dataset.tracked !== 'true' || Number(o.dataset.stock) >= amounts.get(o.value)));
    if (key === 'air' && first.value !== '54106511409480') available = false;
    const subtotal = selected.reduce((sum, option) => sum + Number(option.dataset.unitCents), 0) * count;
    const eligiblePrice = !detail || !Number(detail.dataset.expectedPrice) || Number(detail.dataset.expectedPrice) === Number(first.dataset.unitCents);
    const canDiscount = bundled && eligiblePrice && root.dataset.currency === 'GBP';
    const preview = offers?.dataset.designMode === 'true';
    const active = detail?.dataset.active === 'true';
    const saving = canDiscount && (active || preview) ? Number(detail.dataset.saving) : 0;
    const pending = saving > 0 && !active;
    const total = Math.max(0,subtotal - saving);
    state = { available, bundle:bundled, pending, items:[...amounts].map(([id,quantity])=>({id,quantity})) };
    root.querySelector('[data-single-quantity]').hidden = bundled;
    if(quantity) quantity.disabled = bundled;
    const summary = root.querySelector('[data-offer-summary]'); if(summary) summary.hidden = !bundled;
    if(bundled) {
      root.querySelector('[data-offer-total]').textContent = money(total);
      const original = root.querySelector('[data-offer-original]'); original.hidden = !saving; original.textContent = money(subtotal);
      const saved = root.querySelector('[data-offer-saving]'); saved.hidden = !saving;
      const terms = root.querySelector('[data-offer-terms]'); saved.textContent = terms.dataset.save + ' ' + money(saving); terms.textContent = saving ? terms.dataset.discount : terms.dataset.full;
      root.querySelector('[data-offer-pending]').hidden = !pending;
    }
    root.querySelectorAll('[data-product-price], [data-sticky-price]').forEach(el => el.textContent = bundled || count !== 1 ? money(total) : first.dataset.price);
    buttons.forEach(btn => { btn.disabled = busy || !available || pending; btn.textContent = busy ? root.dataset.addingLabel : !available ? root.dataset.soldLabel : bundled ? root.dataset.bundleAddLabel : root.dataset.addLabel; });
    if (updateImage) showImage(thumbs.find(t => t.dataset.imageId === first.dataset.imageId));
    if (root.dataset.purifier === 'true' && note) note.textContent = first.value === '54106511442248' ? root.dataset.filterNote : root.dataset.setNote;
    if (updateUrl && /^https?:$/.test(window.location.protocol)) { const url = new URL(window.location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url); }
  };
  select?.addEventListener('change', () => {error.hidden=true;sync(true,true);});
  offers?.addEventListener('change', () => {error.hidden=true;sync();});
  quantity?.addEventListener('input',()=>sync());
  window.addEventListener('pageshow', () => { busy=false; form?.removeAttribute('data-submitting');sync(); });
  form?.addEventListener('submit', async event => {
    if (busy) {event.preventDefault();return;}
    sync();
    if (!state.available || state.pending || !form.checkValidity()) {event.preventDefault();form.reportValidity();if(!state.available){error.textContent=root.dataset.stockLabel;error.hidden=false;}return;}
    if (!state.bundle) {busy=true;form.dataset.submitting='true';return;}
    event.preventDefault();busy=true;error.hidden=true;sync();
    try {
      const response = await fetch(root.dataset.rootUrl + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:state.items})});
      const result = await response.json();
      if(!response.ok) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.errorLabel);
      window.location.assign(root.dataset.cartUrl);
    } catch (failure) {error.textContent = failure.message || root.dataset.errorLabel;error.hidden=false;busy=false;sync();}
  });
  sync();
  if (sticky && form && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {const e=entries[0];sticky.hidden=e.isIntersecting || e.boundingClientRect.bottom>0;},{threshold:0});
    observer.observe(form);
    root.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
  }
}
document.querySelectorAll('[data-find-pdp]').forEach(initFindProduct);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-find-pdp]').forEach(initFindProduct));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
